import React from 'react';
import { Star } from 'heroicons-react';

const StarRating = ({ rating }) => {
  const stars = [1, 2, 3, 4, 5];

  return (
    <div className="flex">
      {stars.map((star) => {
        const isFull = star <= rating;
        const isHalf = star - 0.5 === rating;

        return (
          <span key={star} className="relative">
            {isFull ? (
              <Star size={28} color="#F4C343" />
            ) : isHalf ? (
              <div className="relative w-8 h-8">
                <Star size={28} color="#D1D1D1" />
                <div className="absolute top-0 left-0 w-1/2 h-full overflow-hidden">
                  <Star size={28} color="#F4C343" />
                </div>
              </div>
            ) : (
              <Star size={28} color="#D1D1D1" />
            )}
          </span>
        );
      })}
    </div>
  );
};

export default StarRating;
